import axios from "axios";

// change url from here
const BASE_URL = process.env.REACT_APP_BASE_URL;
// const BASE_URL = "https://devapi.tammdone.com";
// Create an Axios instance
const api = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    'x-access-token' : localStorage.getItem("access_token")
  },
});

// Add a request interceptor to include the x-access-token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token"); // Retrieve the token from localStorage
    if (token) {
      config.headers["x-access-token"] = token; // Set the x-access-token header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor to handle responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      console.log("401");
      // Redirect to login page on 401
      window.location.href = "/sign-in";
    } else if (status === 500) {
      console.log("500");
      // Redirect to custom 500 error page
      window.location.href = "/500";
    }

    // Reject promise with the error
    return Promise.reject(error);
  }
);

// Request functions
const apiRequest = {
  get: async (url, params = {}, config = {}) => {
    try {
      const response = await api.get(url, { params, ...config });
      return response.data;
    } catch (error) {
      console.error("GET request failed:", error);
      throw error;
    }
  },

  post: async (url, data = {}, config = {}) => {
    try {
      const response = await api.post(url, data, config);
      return response.data;
    } catch (error) {
      console.error("POST request failed:", error);
      throw error;
    }
  },

  put: async (url, data = {}, config = {}) => {
    try {
      const response = await api.put(url, data, config);
      return response.data;
    } catch (error) {
      console.error("PUT request failed:", error);
      throw error;
    }
  },

  delete: async (url, config = {}) => {
    try {
      const response = await api.delete(url, config);
      return response.data;
    } catch (error) {
      console.error("DELETE request failed:", error);
      throw error;
    }
  },
};

apiRequest.BASE_URL = BASE_URL;

export default apiRequest;
